import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Select from "react-select";
import { adminMainUrl } from "../../../../../../../Config";
import { toast } from "react-toastify";

const AddProduct = ({
  addShow,
  handleAddClose,
  token,
  user_id,
  invoice_id,
  b64id,
  refresh,
  loadingCCExpJobHSNRITCCodeList,
  RITCHSNOptions,
  loadingCCExpJobCurrencyList,
  currencyOptions,

}) => {


  const [disableSubmit, setDisableSubmit] = useState(false);


  const initialValues = {
    custom_clearance_import_job_id: "",
    custom_clearance_import_job_invoice_id: "",
    product_description: "",
    RITC_HSN_code: "",
    quantity: "",
    quantity_currency_type: "",
    SQC_qty: "",
    SQC_qty_type: "",
    unit_price: "",
    unit_price_type: "",
    per: "",
    per_type: "",
    amount: "",
    amount_currency_type: ""
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: (values, { resetForm }) => {
      // console.log(values);
      if (!invoice_id) {
        toast.error("Please select an invoice.");
        return;
      }
      setDisableSubmit(true);
      try {
        let config = {
          headers: {
            'auth-token': token,
            'user_id': user_id
          }
        }

        values.custom_clearance_import_job_id = atob(b64id);
        values.custom_clearance_import_job_invoice_id = invoice_id
        axios.post(`${adminMainUrl}/api/customClearance/import/product/add`, values, config)
          .then(response => {
            if (response.status == 200) {
              toast.success(response?.data?.msg);
              setDisableSubmit(false);
              handleAddClose();
              refresh();
              resetForm();
            } else {
              toast.error(response?.data?.msg);
              setDisableSubmit(false);
            }
          }).catch(error => {
            console.log(error);
            let msg = "Internal server error!";
            if (error.response && error.response.data && error.response.data.msg) {
              msg = error.response.data.msg
            }
            toast.error(msg);
            setDisableSubmit(false);
          })
      } catch (error) {
        console.log(error.message);
        toast.error(error.message);
        setDisableSubmit(false);
      }
    }
  });

  return (
    <>
      <Offcanvas show={addShow} onHide={handleAddClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Product</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-12 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  Description
                </label>
                <textarea name="product_description" id="product_description"
                  className="form-control form-control-sm unset-textarea-height"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.product_description}
                  rows={3}
                ></textarea>
              </div>
              <div className="col-md-6 mt-2">
                <label htmlFor="pickuptype" className="form-label  ">
                  RITC/HSN Code
                </label>
                <Select
                  className="custom-selector"
                  placeholder="Select RITC/HSN Code"
                  name="RITC_HSN_code"
                  options={RITCHSNOptions}
                  onChange={option => {
                    formik.setFieldValue('RITC_HSN_code', option.value);
                  }}
                  value={RITCHSNOptions.find(option => option.value === formik.values.RITC_HSN_code) || null}
                  isLoading={loadingCCExpJobHSNRITCCodeList}
                />
              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Unit Price
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="unit_price"
                      id="unit_price"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.unit_price}
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}

                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Currency
                    </label>
                    <Select
                      className="custom-selector"
                      placeholder="Select Currency"
                      name="unit_price_type"
                      options={currencyOptions}
                      onChange={option => {
                        formik.setFieldValue('unit_price_type', option.value);
                      }}
                      value={currencyOptions.find(option => option.value === formik.values.unit_price_type) || null}
                      isLoading={loadingCCExpJobCurrencyList}
                    />
                  </div>
                </div>

              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Quantity
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      name="quantity"
                      id="quantity"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.quantity}
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Unit
                    </label>
                    <select
                      className="form-control form-control-sm"
                      name="quantity_currency_type"
                      id="quantity_currency_type"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.quantity_currency_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="NOS">NOS</option>
                      <option value="BAG">BAG (Bags)</option>
                      <option value="BGS">BGS (BAGS)</option>
                      <option value="BLK">BLK (Bulk)</option>
                      <option value="BLO">BLO (Steel Blocks)</option>
                      <option value="BLS">BLS (Bails)</option>
                      <option value="BOX">BOX (Boxes)</option>
                      <option value="BRL">BRL (Barrel)</option>
                      <option value="BTL">BTL (Bottles)</option>
                      <option value="BUL">BUL (Steel Bulk)</option>
                      <option value="CAN">CAN (Cans)</option>
                      <option value="CHI">CHI (Chest)</option>
                      <option value="COL">COL (Collies)</option>
                      <option value="CON">CON (Container)</option>
                      <option value="CRI">CRI (Crates)</option>
                      <option value="CRY">CRY (Carboys)</option>
                      <option value="CSK">CSK (Wooden Cases)</option>
                      <option value="CTN">CTN (Cartons)</option>
                      <option value="CYL">CYL (Cylinder)</option>
                      <option value="DOZ">DOZ (Dozen)</option>
                      <option value="DRM">DRM (Drums)</option>
                      <option value="ENV">ENV (Steel Envelopes)</option>
                      <option value="FBK">FBK (Habbuck)</option>
                      <option value="FLK">FLK (Flask)</option>
                      <option value="FUT">FUT (Futs)</option>
                      <option value="GRS">GRS (Gross)</option>
                    </select>
                  </div>

                </div>

              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      SQC Qty.
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      name="SQC_qty"
                      id="SQC_qty"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.SQC_qty}
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Unit
                    </label>
                    <select
                      className="form-control form-control-sm"
                      name="SQC_qty_type"
                      id="SQC_qty_type"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.SQC_qty_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="NOS">NOS</option>
                      <option value="BAG">BAG (Bags)</option>
                      <option value="BGS">BGS (BAGS)</option>
                      <option value="BLK">BLK (Bulk)</option>
                      <option value="BLO">BLO (Steel Blocks)</option>
                      <option value="BLS">BLS (Bails)</option>
                      <option value="BOX">BOX (Boxes)</option>
                      <option value="BRL">BRL (Barrel)</option>
                      <option value="BTL">BTL (Bottles)</option>
                      <option value="BUL">BUL (Steel Bulk)</option>
                      <option value="CAN">CAN (Cans)</option>
                      <option value="CHI">CHI (Chest)</option>
                      <option value="COL">COL (Collies)</option>
                      <option value="CON">CON (Container)</option>
                      <option value="CRI">CRI (Crates)</option>
                      <option value="CRY">CRY (Carboys)</option>
                      <option value="CSK">CSK (Wooden Cases)</option>
                      <option value="CTN">CTN (Cartons)</option>
                      <option value="CYL">CYL (Cylinder)</option>
                      <option value="DOZ">DOZ (Dozen)</option>
                      <option value="DRM">DRM (Drums)</option>
                      <option value="ENV">ENV (Steel Envelopes)</option>
                      <option value="FBK">FBK (Habbuck)</option>
                      <option value="FLK">FLK (Flask)</option>
                      <option value="FUT">FUT (Futs)</option>
                      <option value="GRS">GRS (Gross)</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Per
                    </label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      name="per"
                      id="per"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.per}
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Unit
                    </label>
                    <select
                      className="form-control form-control-sm"
                      name="per_type"
                      id="per_type"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.per_type}
                    >
                      <option value="" disabled>-</option>
                      <option value="NOS">NOS</option>
                      <option value="BAG">BAG (Bags)</option>
                      <option value="BGS">BGS (BAGS)</option>
                      <option value="BLK">BLK (Bulk)</option>
                      <option value="BLO">BLO (Steel Blocks)</option>
                      <option value="BLS">BLS (Bails)</option>
                      <option value="BOX">BOX (Boxes)</option>
                      <option value="BRL">BRL (Barrel)</option>
                      <option value="BTL">BTL (Bottles)</option>
                      <option value="BUL">BUL (Steel Bulk)</option>
                      <option value="CAN">CAN (Cans)</option>
                      <option value="CHI">CHI (Chest)</option>
                      <option value="COL">COL (Collies)</option>
                      <option value="CON">CON (Container)</option>
                      <option value="CRI">CRI (Crates)</option>
                      <option value="CRY">CRY (Carboys)</option>
                      <option value="CSK">CSK (Wooden Cases)</option>
                      <option value="CTN">CTN (Cartons)</option>
                      <option value="CYL">CYL (Cylinder)</option>
                      <option value="DOZ">DOZ (Dozen)</option>
                      <option value="DRM">DRM (Drums)</option>
                      <option value="ENV">ENV (Steel Envelopes)</option>
                      <option value="FBK">FBK (Habbuck)</option>
                      <option value="FLK">FLK (Flask)</option>
                      <option value="FUT">FUT (Futs)</option>
                      <option value="GRS">GRS (Gross)</option>
                    </select>
                  </div>
                </div>
              </div>


              <div className="col-md-6 mt-2">
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Amount
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="amount"
                      id="amount"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.amount}
                      maxLength={15}
                      onInput={(event) => {
                        let value = event.target.value;
                        value = value.replace(/[^0-9]/g, '');
                        event.target.value = value;
                      }}

                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="pickuptype" className="form-label  ">
                      Currency
                    </label>
                    <Select
                      className="custom-selector"
                      placeholder="Select Currency"
                      name="amount_currency_type"
                      options={currencyOptions}
                      onChange={option => {
                        formik.setFieldValue('amount_currency_type', option.value);
                      }}
                      value={currencyOptions.find(option => option.value === formik.values.amount_currency_type) || null}
                      isLoading={loadingCCExpJobCurrencyList}
                    />
                  </div>
                </div>

              </div>
            </div>

            <div className="row d-flex justify-content-end mt-2">
              <div className="col-md-6 d-flex justify-content-end">
                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                  {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddProduct
